import { RecipeModifyFormValues } from '../models/form-values';
import { Action } from '@ngrx/store';
import { ModifyOnlineOrderFormConfig } from '../models/modify-online-order-form-config';
import { ParameterResponse } from '@cemex-core/cmx-api';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { ConfirmOfferRequest } from '@cemex-core/cmx-api/models/order-management/confirm-offer-request';

export enum ModifyOnlineOrderActionTypes {
  INIT = '[Bulk CEM UL Modify] Init',
  RESET = '[Bulk CEM UL Modify] Reset',
  RESET_JOBSITE_SELECTION = '[Bulk CEM UL Modify] Reset jobsite',
  ADD_ITEM = '[Bulk CEM UL Modify] Add recipe item',
  DUPLICATE_ITEM = '[Bulk CEM UL Modify] Duplicate recipe item',
  UPDATE_ITEM = '[Bulk CEM UL Modify] Update recipe item',
  RESET_DATE_TIME = '[Bulk CEM UL Modify] Reset date & time',
  FETCH_ITEM_CONTRACTS = '[Bulk CEM UL Modify] Fetch Item Contracts',
  STORE_ITEM_CONTRACTS = '[Bulk CEM UL Modify] Store Item Contracts',
  OP_FETCH_UNITS = '[Bulk CEM UL Modify - Unit] fetch volume units',
  OP_STORE_UNITS = '[Bulk CEM UL Modify - Unit] store volume units',
  SET_ITEMS_SEQ_NUM = '[Bulk CEM UL Modify] Set items seq num',
  RESET_ITEMS_SEQ_NUM = '[Bulk CEM UL Modify] Reset items seq num',
  SET_ADDITIONAL_SERVICES = '[Bulk CEM UL Modify] Set additional services',
  SET_INVOICE_LOADED = '[Bulk CEM UL Modify] Set invoice loaded',
  REMOVE_ITEM = '[Bulk CEM UL Modify] Remove recipe item',
  LOCK_ITEM = '[Bulk CEM UL Modify] Lock recipe item',
  SET_FOR_DC_VALIDATION = '[Bulk CEM UL Modify] set for dc validation',
  SET_INITIAL_LOAD = '[Bulk CEM UL Modify] set intial load',
  SET_FORM_VALID = '[Bulk CEM UL Modify] set IS valid form Form',
  SET_DC_VALIDATION = '[Bulk CEM UL Modify] set DC validation',
  SET_DIRTY = '[Bulk CEM UL Modify] set dirty',
  SET_RECEIVING_PERSON = '[Bulk CEM UL Modify] Set receiving person',
  NO_ACTION = '[Bulk CEM UL Modify] Form No Action',
  SET_SPECIAL_INSTRUCTIONS_REQUEST = '[Bulk CEM UL Modify] set special instructions request',
  SET_PURCHASE_ORDER_REQUEST = '[Bulk CEM UL Modify] set purchase order request',
  SET_ORDER_ID = '[Bulk CEM UL Modify] set order id',
  SET_CATALOG_FALSE = '[Bulk CEM UL Modify] set catalog as false',
  SET_CONTACT_PERSON_FORM_CONFIG = '[Bulk CEM UL Modify] Save add contact form-config for modal.',
  SET_ERROR_ON_VALIDATION = '[Bulk CEM UL Modify] error on order validation.',
  SET_PROCESSING_FORM = '[Bulk CEM UL Modify] set processing form.',
  VALIDATE_FORMS = '[Bulk CEM UL Modify] validate Forms.',
  SET_STOP_PROCESSING_FORM = '[Bulk CEM UL Modify] set stop processing form',
  SET_BUCKETS_TO_CANCEL = '[Bulk CEM UL Modify] set buckets to cancel',
  CANCEL_BUCKETS = '[Bulk CEM UL Modify] cancel buckets',
  RESET_TIME_TO = '[Bulk CEM UL Modify] reset time to',
}

export class FetchItemContracts implements Action {
  readonly type = ModifyOnlineOrderActionTypes.FETCH_ITEM_CONTRACTS;
  constructor(public payload: { productId: number; orderId: number }) {}
}

export class StoreItemContracts implements Action {
  readonly type = ModifyOnlineOrderActionTypes.STORE_ITEM_CONTRACTS;
  constructor(public payload: { orderId: number; contracts: any[] }) {}
}

export class LocationSpecificationLoadAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.INIT;

  constructor(public payload: ModifyOnlineOrderFormConfig) {}
}

export class LocationSpecificationAddItemAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.ADD_ITEM;

  constructor() {}
}

export class LocationSpecificationDuplicateItemAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.DUPLICATE_ITEM;

  constructor(public payload: { [key: string]: any }) {}
}

export class LocationSpecificationUpdateItemAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.UPDATE_ITEM;

  constructor(
    public payload: {
      recipeFromValues: RecipeModifyFormValues;
      previousValues: RecipeModifyFormValues;
      isOnline: boolean;
      purchaseOrderValid: boolean;
      automaticValidation: boolean;
    },
  ) {}
}

export class LocationSpecificationResetDateTimeAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.RESET_DATE_TIME;
  constructor() {}
}

export class LocationSpecificationSetItemsSeqAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_ITEMS_SEQ_NUM;

  constructor() {}
}

export class LocationSpecificationResetItemsSeqAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.RESET_ITEMS_SEQ_NUM;

  constructor() {}
}

export class LocationSpecificationLockRecipeAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.LOCK_ITEM;

  constructor(public payload: { orderFormId: number; locked: boolean; loadingInvoice: boolean }) {}
}

export class SetProcessingFormsAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_PROCESSING_FORM;

  constructor(public payload: { locked: boolean }) {}
}

export class SetForRevalidateRecipeAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_FOR_DC_VALIDATION;

  constructor(public payload: { orderFormId: number; invokeDC: boolean; resetTime: boolean }) {}
}

export class SetValidRecipeAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_FORM_VALID;

  constructor(public payload: { orderFormId: number; formValid: boolean }) {}
}

export class SetDirtyRecipeAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_DIRTY;

  constructor(public payload: { orderFormId?: number; dirty?: boolean; dirtyAll?: boolean }) {}
}

export class SetErrorAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_ERROR_ON_VALIDATION;

  constructor(public payload: { orderFormId?: number; hasError?: boolean }) {}
}
export class SetInitialLoadAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_INITIAL_LOAD;
  constructor(public payload: { orderFormId?: number; isInitialLoad: boolean; isInitialLoadAll?: boolean }) {}
}

export class SetDCValidationRecipeAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_DC_VALIDATION;

  constructor(public payload: { orderFormId: number; DCResponse: ParameterResponse }) {}
}

export class LocationSpecificationRemoveItemAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.REMOVE_ITEM;

  constructor(public payload: number) {}
}

export class LocationSpecificationSetInvoiceLoadedAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_INVOICE_LOADED;

  constructor(public payload: boolean) {}
}

export class LocationSpecificationResetAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.RESET;

  constructor() {}
}

export class LocationSpecificationResetJobsiteSelectionAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.RESET_JOBSITE_SELECTION;

  constructor() {}
}

export class LocationSpecificationSetSpecialInstructionsRequest implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_SPECIAL_INSTRUCTIONS_REQUEST;

  constructor(public payload: string) {}
}

export class LocationSpecificationSetPurchaseOrderRequest implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_PURCHASE_ORDER_REQUEST;

  constructor(public payload: string) {}
}

export class LocationSpecificationSetOrderId implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_ORDER_ID;

  constructor(public payload: { orderFormId: number; orderId: number }) {}
}
export class LocationSpecificationSetReceivingPersonAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_RECEIVING_PERSON;
  // payload = receiving person contactId
  constructor(public payload: number) {}
}

export class LocationSpecificationCatalogFalse implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_CATALOG_FALSE;
  constructor() {}
}

export class SetContactPersonFormConfig implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_CONTACT_PERSON_FORM_CONFIG;
  constructor(public payload: FieldConfig[]) {}
}

export class NoAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.NO_ACTION;
  constructor() {}
}

export class ValidateForms implements Action {
  readonly type = ModifyOnlineOrderActionTypes.VALIDATE_FORMS;
  constructor() {}
}

export class SetStopProcessingFormAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_STOP_PROCESSING_FORM;
  constructor(public payload: { stopProcessingForm: boolean }) {}
}

export class SetBucketsToCancelAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.SET_BUCKETS_TO_CANCEL;

  constructor(public payload: { previousForm: RecipeModifyFormValues }) {}
}

export class CancelBucketsAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.CANCEL_BUCKETS;
  constructor(public payload: { orderId: number; bucketsToCancel: ConfirmOfferRequest }) {}
}

export class ResetTimeToAction implements Action {
  readonly type = ModifyOnlineOrderActionTypes.RESET_TIME_TO;

  constructor(public payload: boolean) {}
}


export type ModifyOnlineOrderAction =
  | LocationSpecificationLoadAction
  | LocationSpecificationResetAction
  | LocationSpecificationAddItemAction
  | LocationSpecificationDuplicateItemAction
  | LocationSpecificationUpdateItemAction
  | LocationSpecificationResetDateTimeAction
  | LocationSpecificationSetItemsSeqAction
  | LocationSpecificationResetItemsSeqAction
  | LocationSpecificationSetInvoiceLoadedAction
  | LocationSpecificationRemoveItemAction
  | FetchItemContracts
  | StoreItemContracts
  | LocationSpecificationLockRecipeAction
  | SetProcessingFormsAction
  | LocationSpecificationResetJobsiteSelectionAction
  | SetForRevalidateRecipeAction
  | SetDCValidationRecipeAction
  | LocationSpecificationSetReceivingPersonAction
  | SetDirtyRecipeAction
  | SetInitialLoadAction
  | LocationSpecificationSetSpecialInstructionsRequest
  | LocationSpecificationSetPurchaseOrderRequest
  | LocationSpecificationSetOrderId
  | LocationSpecificationCatalogFalse
  | SetContactPersonFormConfig
  | SetErrorAction
  | SetValidRecipeAction
  | SetStopProcessingFormAction
  | SetBucketsToCancelAction
  | CancelBucketsAction
  | NoAction
  | ResetTimeToAction;
